import { makeStyles } from '@rbx/ui';

export const actionBarIconSize = 18;

const useBotMessageActionBarStyles = makeStyles()((theme) => ({
  streamingIndicator: {
    marginTop: 0,
  },

  iconWrapper: {
    padding: theme.spacing(1 / 2),
    marginRight: theme.spacing(1),
    '& svg': {
      height: actionBarIconSize,
      width: actionBarIconSize,
      fill: theme.palette.content.muted,
      opacity: 0.5,
    },
  },
}));

export default useBotMessageActionBarStyles;
